// @ts-check
import NumericInput from 'Components/Common/numericInput';
import Popup from "Components/Common/popup";
import 'Styles/commonComponents/settings/numericSetting.scss';
import IconsContainer from "Utils/IconsContainer";
import { observer } from 'mobx-react';
import React from "react";

/**
 * @param {{
 * id?: string | undefined,
 * title: string,
 * helperText?: string | undefined,
 * minValue: number,
 * maxValue: number,
 * value: number,
 * valueChanged: (val: number) => void
 * }} props 
 * @returns {React.JSX.Element}
 */
const NumericSetting = (props) => {
    return (
        <div className='setting-container numeric-setting'>

            <div className='setting-title numeric-setting-title'>
                {props.title}
                {props.helperText ?
                    <Popup
                        popupText={props.helperText}
                        className='fast-info-popup'>
                        {IconsContainer.Get('ci-info')}
                    </Popup>
                    : ''}
            </div>

            <NumericInput
                minValue={props.minValue}
                maxValue={props.maxValue}
                setValue={props.valueChanged}
                getValue={_ => props.value}
                onResetToDefaultMin={props.onResetToDefaultMin}
                onResetToDefaultMax={props.onResetToDefaultMax}
            />

        </div>
    )
}

export default observer(NumericSetting);